import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { TrackingZone } from 'libs/growth-platform-brand-system-v2/src/utils/tracking';
import React, { useRef } from 'react';
import { Menu } from './Menu';
import { Banner } from './banner';
import { useStickyMenu } from './useStickyMenu';

export const Header = ({ menu, locale, pageContext }: any) => {
  const menuRef = useRef<any>(null);
  const headerRef = useRef<any>(null);
  const isSticky = useStickyMenu(menuRef);

  const headerButton = menu?.headerButton;
  const mobileButton = menu?.mobileButton;
  const menuItems = menu?.menuItems;

  const banner = menu?.banner?.[0];

  if (!menu) return null;

  return (
    <TrackingZone.Provider value={'menu'}>
      <div
        ref={headerRef}
        className={classNames('Header', 'relative z-[100] w-full')}
      >
        {banner?.text && (
          <Banner
            {...banner}
            tag={banner?.tag?.[0] || undefined}
            locale={locale}
          />
        )}
        <header
          ref={menuRef}
          className={classNames(
            `headerPage w-full border-neutral-21 bg-white`,
            isSticky && 'sticky',
          )}
        >
          <div
            className={classNames(
              'relative flex w-full items-center px-24 md:px-40',
            )}
          >
            <Menu
              {...{
                headerButton,
                mobileButton,
                menuItems,
                locale,
                menu,
                pageContext,
              }}
            />
          </div>
        </header>
      </div>
    </TrackingZone.Provider>
  );
};
